<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import CompaniesTable, {CompaniesTable as _CompaniesTable} from '@/components/account/CompaniesTable.vue'

    @Component({mixins: [CompaniesTable]})
    export class SuppliersTable extends _CompaniesTable {
        goToCompanyClientProfile(id) {
            this.$router.push({name: 'companySupplier', params: {id}})
        }

        async changeActive(item) {
            const {id, active} = item
            try {
                await this.$api.companies.patch(id, {active})
                const companiesUpdated = [...runtimeStore.companies]
                companiesUpdated.find(c => c.id === id).active = active
                runtimeStore.SET_COMPANIES(companiesUpdated)
                this.$toast.success(this.$t('data_updated'))
            } catch (e) {
                await runtimeStore.loadCompanies({
                    // companyId: authStore.person.companyId,
                    relationship: this.relationship,
                    active: false,
                })
                this.$toast.error(this.$t('data_update_fail'))
            } finally {
                await this.loadCompanies()
            }
        }

        dontAllowEdit(item) {
            return item?.type === 'HUB_SUPPLIER'
        }

        get headers() {
            const headers = super.headers
            return headers.filter(({value}) => value !== 'groupOfContracts' && value !== 'currentBalance')
        }
    }

    export default {...toNative(SuppliersTable), ssrRender: CompaniesTable.ssrRender}
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';
    :deep(div) {
        td:not(:first-of-type) {
            min-width: 120px;
            white-space: break-spaces;
        }
    }

    @media #{map.get(settings.$display-breakpoints, 'md-and-down')} {
        :deep(div) {
            tr {
                td:first-of-type,
                td:nth-of-type(2),
                th:first-of-type,
                th:nth-of-type(2) {
                    position: sticky;
                    border-right: none;
                    background: map.get(settings.$grey, 'lighten-5');
                }
                td:first-of-type,
                th:first-of-type {
                    left: 0;
                }
                td:nth-of-type(2),
                th:nth-of-type(2) {
                    left: 44px;
                }
            }
        }
    }
</style>
